import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { notify } from 'libs/common';
import { user } from 'services';
import { themes, Button } from '../buttons';
import { clearViolations } from 'services/payments-service';
import { Content, Label, Value, Cnt } from './violations-cnt.styled';

export const ViolationsCnt = (props) => {
  const { vehicle_plate, cnt, refresh } = props;
  const { t } = useTranslation();
  const [cnt1, setCnt1] = useState(cnt);
  const [loading, setLoading] = useState(false);
  const right = user.haveRight('violations.change_state');

  const show = !user.inInterface('reports_violations');
  // console.log("show", show);
  // console.log('show', show);
  if (cnt1 === 0 || !show) {
    return null;
  }

  /**
   * archive violations
   */
  const archive = () => {
    setLoading(true);
    clearViolations(vehicle_plate)
      .then((data) => {
        console.log('data', data);
        setCnt1(data.violations_count);
        setLoading(false);
        refresh();
        notify(t('messages.ВНИМАНИЕ!'), t('form.Нарушения успешно архивированы'), 'success');
      })
      .catch((error) => {
        setLoading(false);
        notify(t('messages.ВНИМАНИЕ!'), error?.message);
      });
  };

  const cl = loading ? 'loading' : '';

  return (
    <Content className={cl}>
      <Label>{t('form.Активных нарушений')}</Label>
      <Value>
        <Cnt>{cnt1}</Cnt>
        {right && (
          <Button theme={themes.blue} onClick={archive} type="button">
            {t('form.Архивировать нарушения')}
          </Button>
        )}
      </Value>
    </Content>
  );
};

ViolationsCnt.propTypes = {
  vehicle_plate: PropTypes.string.isRequired,
  cnt: PropTypes.number,
  refresh: PropTypes.func.isRequired,
};
